import {
  pointerWithin,
  rectIntersection,
  type Announcements,
  type CollisionDetection,
} from "@dnd-kit/core";

/** Pointeur sur un champ : on vise ce champ ; sinon la colonne sous le pointeur (utile pour une colonne vide). */
export const preferItemsOverColumns =
  (isColumn: (id: string) => boolean): CollisionDetection =>
  (args) => {
    const pointer = pointerWithin(args);
    const hits = pointer.length > 0 ? pointer : rectIntersection(args);
    const item = hits.find((hit) => !isColumn(String(hit.id)));
    return item ? [item] : hits;
  };

export const SCREEN_READER_INSTRUCTIONS = {
  draggable:
    "Pour déplacer cet élément, appuyez sur la barre d'espace, utilisez les flèches pour le positionner, puis espace pour le déposer. Échap annule le déplacement.",
};

/** Annonces vocales en français pour les lecteurs d'écran. */
export const frenchAnnouncements = (
  labelOf: (id: string) => string,
): Announcements => ({
  onDragStart: ({ active }) => `« ${labelOf(String(active.id))} » saisi.`,
  onDragOver: ({ active, over }) =>
    over
      ? `« ${labelOf(String(active.id))} » est au-dessus de « ${labelOf(String(over.id))} ».`
      : undefined,
  onDragEnd: ({ active, over }) =>
    over
      ? `« ${labelOf(String(active.id))} » déposé sur « ${labelOf(String(over.id))} ».`
      : `« ${labelOf(String(active.id))} » déposé.`,
  onDragCancel: ({ active }) =>
    `Déplacement de « ${labelOf(String(active.id))} » annulé.`,
});
